import { useTranslation } from "react-i18next";
import { CircleCheck } from "lucide-react";
import { useCheckInSend } from "../context";
import { useAudio } from "../../../../../lib/use-audio";
import { KioskStep } from "../../../../../components/kiosk-step";
import { KioskStatePanel } from "../../../../../components/kiosk-state-panel";

/**
 * Card check-in confirmation step: the card was read; the patient confirms
 * the check-in with the footer action.
 *
 * @since 1.0.0
 * @example
 * ```tsx
 * <CardCheckinStep />
 * ```
 */
export function CardCheckinStep() {
  const { t } = useTranslation();
  const send = useCheckInSend();
  useAudio("checkIn-cardCheckin");

  return (
    <KioskStep
      width="narrow"
      align="center"
      title={t("self-service.check-in.card-checkin.title")}
      primaryAction={{
        label: t("self-service.check-in.card-checkin.confirm"),
        icon: CircleCheck,
        onClick: () => send({ type: "CONFIRM_DIFFS" }),
        testId: "card-checkin-confirm",
      }}
    >
      <KioskStatePanel
        tone="success"
        title={t("self-service.check-in.card-checkin.subtitle")}
      />
    </KioskStep>
  );
}
